import { Modal } from '@round/whitelabel-ui';
import { creatorbase } from '@round/api';
import styles from './BillingEntitySettingsModal.module.css';
import { Button } from '@round/whitelabel-ui';

type Props = {
    isOpen: boolean;
    onClose: () => void;
    billingEntity: creatorbase.BillingEntity | null;
};

const BillingEntitySettingsModal = ({ isOpen, onClose, billingEntity }: Props) => {
    if (!billingEntity) {
        return null;
    }

    return (
        <Modal isOpen={isOpen} onClose={onClose} closeOnOverlayClick closeOnEscape className={styles.modal}>
            <Modal.Header>
                <Modal.Title>Billing Entity Settings</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div>
                    <p>{billingEntity.name}</p>
                    <p>{billingEntity.email_address}</p>
                </div>
            </Modal.Body>
            <Modal.Actions>
                <Button appearance="primary" onClick={() => {}}>
                    Save
                </Button>
                <Button appearance="ghost" onClick={onClose}>
                    Close
                </Button>
            </Modal.Actions>
        </Modal>
    );
};

export default BillingEntitySettingsModal;
